class ConnectionChangeContextIsNotInitialized extends Error {
    constructor() {
        super('useConnectionChange must be used within a ConnectionChangeProvider');
    }
}
class SetConnectionChangeDataImplementationNotAvailable extends Error {
    value;
    constructor(value) {
        super('Set connection change data implementation not available');
        this.value = value;
    }
}
export { ConnectionChangeContextIsNotInitialized, SetConnectionChangeDataImplementationNotAvailable };
